export default class FactureAvoirInitController {

    static $inject = [
        '$scope',
        '$stateParams',
        '$state',
        'AvoirsService',
        'notification',
        'ModalService',
        '$uibModal',
        'moment',
        '$translate'
    ];

    constructor($scope, $stateParams, $state, AvoirsService, notification, ModalService, $uibModal, moment, $translate) {
        this.$scope = $scope;
        this.$stateParams = $stateParams;
        this.$state = $state;
        this.AvoirsService = AvoirsService;
        this.notification = notification;
        this.ModalService = ModalService;
        this.$uibModal = $uibModal;
        this.moment = moment;
        this.$translate = $translate;
    }

    async $onInit() {
        const watchers = [];
        this.step = 1;
        this.isDisabled = false;
        this.title = this.$translate.instant('FACTURES.AVOIR.AVOIR_SUR_FACTURE_TITLE', { nb: this.idFactures.length });
        this.dateAvoir = await this.moment().format('DD/MM/YYYY');
        this.changeDate();

        watchers.push(
			this.$scope.$watch('$ctrl.dateAvoir', (newValue, oldValue) => {
				if (newValue && newValue != oldValue) {
					this.changeDate();
				}
			})
		);
    }

    annuler() {
        this.modalInstance.close();
    }

    avoirTotal() {
        this.step = 2;
        this.isDisabled = false;
        this.title = this.$translate.instant('FACTURES.AVOIR.CREATION_AVOIR_TOTAL');
    }

    changeDate() {
        const dateFacture = this.moment.utc(this.dateFacture, 'DD/MM/YYYY', true);
        const dateAvoir = this.moment.utc(this.dateAvoir, 'DD/MM/YYYY', true);
        if (dateAvoir.isSameOrAfter(dateFacture)) {
            this.isDisabled = false;     
        }
        else {
            this.isDisabled = true;
        }
    }

    avoirRefacturation() {
        this.modalInstance.close();
        var _this = this;
        this.$uibModal.open({
            template:
                '<facture-avoir-select id-factures="$ctrl.idFactures" date="$ctrl.date" modal-instance="$ctrl.uibModalInstance"></facture-avoir-select>',
            controller: [
                '$uibModalInstance',
                function ($uibModalInstance) {
                    var $ctrl = this;
                    $ctrl.idFactures = _this.idFactures;
                    $ctrl.date = _this.dateAvoir;
                    $ctrl.uibModalInstance = $uibModalInstance;
                },
            ],
            controllerAs: '$ctrl',
            size: 'xl',
            backdrop: false
        });
    }
 
    async createAvoir() {
        try {
            this.startLoading();
            let avoirResult = await this.AvoirsService.getAvoir(this.idFactures, true);
            avoirResult.type = 0;
            avoirResult.dateValorisation = this.dateAvoir;
            const recap = await this.AvoirsService.createAvoir(avoirResult);
            this.modalInstance.close();
            this.$uibModal.open({
                template:
                    '<facture-avoir-recap recap="$ctrl.recap" modal-instance="$ctrl.uibModalInstance"></facture-avoir-recap>',
                controller: [
                    '$uibModalInstance',
                    function ($uibModalInstance) {
                        var $ctrl = this;
                        $ctrl.recap = recap;
                        $ctrl.uibModalInstance = $uibModalInstance;
                    },
                ],
                controllerAs: '$ctrl',
                size: 'l',
                backdrop: false
            }); 
            this.notification.success(this.$translate.instant('FACTURES.POPUP.SUCCESSAVOIR'));
        } catch (ex) {
            this.notification.error(ex.data);
        } finally {
            this.stopLoading();
        }
    }

    startLoading() {
        this.loading = true;
    }

    stopLoading() {
        this.loading = false;
    }
}
